import * as React from "react"

import { cn } from "@/lib/utils"

interface LoadingSpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "default" | "lg"
  text?: string
}

function LoadingSpinner({
  className,
  size = "default",
  text,
  ...props
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: "size-8 border-2",
    default: "size-16 border-4",
    lg: "size-24 border-[6px]",
  }

  return (
    <div
      className={cn("flex flex-col items-center justify-center gap-4", className)}
      {...props}
    >
      <div
        className={cn(
          "animate-spin rounded-full border-primary border-t-transparent",
          sizeClasses[size]
        )}
      />
      {text && (
        <p className="text-muted-foreground text-lg animate-pulse">{text}</p>
      )}
    </div>
  )
}

export { LoadingSpinner }
